import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import styles from '../RoomDiscount.module.scss';
import type { DefaultDiscountMode } from '../hooks/useRoomDiscountLogic';

import { DefaultDiscountSection } from './DefaultDiscountSection';
import { LastMinuteDiscountSection } from './LastMinuteDiscountSection';

type RoomDiscountContentProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  discountMode: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
  getDayBasePrice: (day: DayOfWeek) => number | null | undefined;
  onDiscountModeChange: (mode: DefaultDiscountMode) => void;
  lastMinuteNightRoomDiscountRate?: number | null;
  isLastMinuteEnabled: boolean;
  onLastMinuteToggle: (value: boolean) => void;
};

export const RoomDiscountContent = ({
  currencyFormatter,
  formRoomPrice,
  discountMode,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
  getDayBasePrice,
  onDiscountModeChange,
  lastMinuteNightRoomDiscountRate,
  isLastMinuteEnabled,
  onLastMinuteToggle,
}: RoomDiscountContentProps) => {
  const isLastMinuteDisabled =
    discountMode === 'CONSTANT' &&
    (defaultNightRoomDiscount === null ||
      defaultNightRoomDiscount === undefined);

  return (
    <div className={styles.discountsList}>
      <DefaultDiscountSection
        currencyFormatter={currencyFormatter}
        formRoomPrice={formRoomPrice}
        discountMode={discountMode}
        defaultNightRoomDiscount={defaultNightRoomDiscount}
        defaultNightRoomDiscountDays={defaultNightRoomDiscountDays}
        getDayBasePrice={getDayBasePrice}
        onDiscountModeChange={onDiscountModeChange}
      />
      <LastMinuteDiscountSection
        currencyFormatter={currencyFormatter}
        formRoomPrice={formRoomPrice}
        disabled={isLastMinuteDisabled}
        lastMinuteNightRoomDiscountRate={lastMinuteNightRoomDiscountRate}
        isLastMinuteEnabled={isLastMinuteEnabled}
        onLastMinuteToggle={onLastMinuteToggle}
      />
    </div>
  );
};
